import { xhr } from '@services/http/xhr';
import { Metadata } from './interfaces';

export const get = <A extends Metadata.Action>(data: Metadata.Get.Params<A>): Promise<Metadata.Get.Response<A>> => {
  return xhr.post(`/auth/metadata`, data)
    .then(res => res.data);
};